export default [{
    title: 'Perfil',
    name: 'profile',
    path: '/profile',
    component: () => import( /* webpackChunkName: "profile" */ './Profile')
},
{
    title: 'Revogado',
    name: 'revoked',
    path: '/revoked',
    component: () => import( /* webpackChunkName: "profile" */ './Revoked')
}]